import { Button, Dialog } from '@material-ui/core'
import React from 'react'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogActions from '@material-ui/core/DialogActions'

export const LiveUpdateDialog = ({ open, onClose, onYes }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>
        Save live questionnaire?
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          You are trying to update a questionnaire that already has responses.
          Are you sure you want to proceed?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button id='noToLiveUpdate' onClick={onClose} color='primary'>
          No
        </Button>
        <Button id='yesToLiveUpdate' onClick={onYes} color='primary' autoFocus>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  )
}
